import {
  Section,
  TextDisplay,
  TextDisplayHighlight,
} from '@angeplus/prever-component-lib';

export const PetHomeTextDisplay = () => (
  <Section>
    <TextDisplay>
      Cuide dos seus <TextDisplayHighlight>pets</TextDisplayHighlight> em todos
      os momentos
    </TextDisplay>
  </Section>
);
